<mat-card>
  <mat-card-header>
    <mat-card-title> Kundkännedom</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p>Här kan du lämna uppdaterad kundkännedom för Borgo.</p>

    <p>För att gå vidare behöver du ha ett BankID.</p>

    <p>Saknar du ett BankID är du välkommen att besöka ett av våra kontor,
      <a
        spbAccessibleLink
        href="https://www.sparbankensyd.se/privat/om-oss/kontakt"
        target="_blank">klicka här för kontaktinformation</a>.
    </p>

    <div>
      <spb-bankid (accessToken)="configService.setToken($event)"
                  [bankIdUrl]="bankIdUrl"
                  [domain]="domain"
                  mode="login"
                  customButton="Öppna BankID"
      />
    </div>
  </mat-card-content>
</mat-card>

